/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { GrundbuchmeldungSearchRequest } from '../model/models';
import { GrundbuchmeldungSearchRequestMeta } from '../model/models';
import { GrundbuchmeldungSearchResponseMeta } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class GbgrundbuchmeldungService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param sprache 
     * @param grundbuchmeldungSearchRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip'}): Observable<Array<string>>;
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip'}): Observable<HttpResponse<Array<string>>>;
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/zip'}): Observable<HttpEvent<Array<string>>>;
    public downloadGrundbuchmeldungZip(sprache: string, grundbuchmeldungSearchRequest: GrundbuchmeldungSearchRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/zip'}): Observable<any> {
        if (sprache === null || sprache === undefined) {
            throw new Error('Required parameter sprache was null or undefined when calling downloadGrundbuchmeldungZip.');
        }
        if (grundbuchmeldungSearchRequest === null || grundbuchmeldungSearchRequest === undefined) {
            throw new Error('Required parameter grundbuchmeldungSearchRequest was null or undefined when calling downloadGrundbuchmeldungZip.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/zip'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<Array<string>>(`${this.configuration.basePath}/gb/grundbuchmeldung/grundbuchmeldungZip/${encodeURIComponent(String(sprache))}`,
            grundbuchmeldungSearchRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gbaId 
     * @param jahr 
     * @param tbnr 
     * @param index 
     * @param gdeId 
     * @param gsNr 
     * @param gsnrZusatz 
     * @param gsNr3 
     * @param gsNr4 
     * @param egrid 
     * @param egDatumVon 
     * @param egDatumBis 
     * @param absDatumVon 
     * @param absDatumBis 
     * @param status 
     * @param name 
     * @param vorname 
     * @param versNr 
     * @param egid 
     * @param bearbeitet 
     * @param nichtBearbeitet 
     * @param registraturText 
     * @param regionId 
     * @param timepoint 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timepoint?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchmeldungSearchResponseMeta>;
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timepoint?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchmeldungSearchResponseMeta>>;
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timepoint?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchmeldungSearchResponseMeta>>;
    public searchGrundbuchmeldung(gbaId?: string, jahr?: string, tbnr?: string, index?: string, gdeId?: string, gsNr?: string, gsnrZusatz?: string, gsNr3?: string, gsNr4?: string, egrid?: string, egDatumVon?: string, egDatumBis?: string, absDatumVon?: string, absDatumBis?: string, status?: string, name?: string, vorname?: string, versNr?: string, egid?: string, bearbeitet?: boolean, nichtBearbeitet?: boolean, registraturText?: string, regionId?: string, timepoint?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (gbaId !== undefined && gbaId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gbaId, 'gbaId');
        }
        if (jahr !== undefined && jahr !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>jahr, 'jahr');
        }
        if (tbnr !== undefined && tbnr !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>tbnr, 'tbnr');
        }
        if (index !== undefined && index !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>index, 'index');
        }
        if (gdeId !== undefined && gdeId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gdeId, 'gdeId');
        }
        if (gsNr !== undefined && gsNr !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gsNr, 'gsNr');
        }
        if (gsnrZusatz !== undefined && gsnrZusatz !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gsnrZusatz, 'gsnrZusatz');
        }
        if (gsNr3 !== undefined && gsNr3 !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gsNr3, 'gsNr3');
        }
        if (gsNr4 !== undefined && gsNr4 !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gsNr4, 'gsNr4');
        }
        if (egrid !== undefined && egrid !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>egrid, 'egrid');
        }
        if (egDatumVon !== undefined && egDatumVon !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>egDatumVon, 'egDatumVon');
        }
        if (egDatumBis !== undefined && egDatumBis !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>egDatumBis, 'egDatumBis');
        }
        if (absDatumVon !== undefined && absDatumVon !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>absDatumVon, 'absDatumVon');
        }
        if (absDatumBis !== undefined && absDatumBis !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>absDatumBis, 'absDatumBis');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'status');
        }
        if (name !== undefined && name !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>name, 'name');
        }
        if (vorname !== undefined && vorname !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>vorname, 'vorname');
        }
        if (versNr !== undefined && versNr !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>versNr, 'versNr');
        }
        if (egid !== undefined && egid !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>egid, 'egid');
        }
        if (bearbeitet !== undefined && bearbeitet !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>bearbeitet, 'bearbeitet');
        }
        if (nichtBearbeitet !== undefined && nichtBearbeitet !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>nichtBearbeitet, 'nichtBearbeitet');
        }
        if (registraturText !== undefined && registraturText !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>registraturText, 'registraturText');
        }
        if (regionId !== undefined && regionId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>regionId, 'regionId');
        }
        if (timepoint !== undefined && timepoint !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>timepoint, 'timepoint');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchmeldungSearchResponseMeta>(`${this.configuration.basePath}/gb/grundbuchmeldung/search`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchTemplateGrundbuchmeldung(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<GrundbuchmeldungSearchRequestMeta>;
    public searchTemplateGrundbuchmeldung(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<GrundbuchmeldungSearchRequestMeta>>;
    public searchTemplateGrundbuchmeldung(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<GrundbuchmeldungSearchRequestMeta>>;
    public searchTemplateGrundbuchmeldung(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<GrundbuchmeldungSearchRequestMeta>(`${this.configuration.basePath}/gb/grundbuchmeldung/searchTemplate`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
